meedy.controller('meedy.calendarIndexController', ['$scope', '$state', '$stateParams', '$interval', '$timeout', '$mdDialog', '$mdToast', '$window', 'meedy.objectHelper', 'applicationModel', 'meedy.resourceModel', 'meedy.availabilityRuleModel', 'meedy.calendarModel', 'meedy.userModel', 'meedy.termModel',
	function ($scope, $state, $stateParams, $interval, $timeout, $mdDialog, $mdToast, $window, objectHelper, applicationModel, resourceModel, availabilityRuleModel, calendarModel, userModel, termModel) {
		
		var timePollingPromise = null;
		
		function isSameDate(moment1, moment2) {
			return moment2.isSame(moment1, 'year') && moment2.isSame(moment1, 'month') && moment2.isSame(moment1, 'day');
		}
		
		function getColorForTerm(term) {
			if (term.type === Enum.MEEDY.TERM_TYPE.PRIVATE_TERM) {
				return Constant.MEEDY.TERM.PRIVATE_TERM_COLOR;
			} else {
				if (term.resource) {
					return term.resource.color;
				}
				return Constant.MEEDY.TERM.DELETED_TERM_COLOR;
			}
			
		}
		
		function getYPositionByDate(date) {
			var momentDate = moment(date);
			var paddingTop = $scope.displayAllResources ? 54 : 10;
			return (momentDate.hour() * 60 + momentDate.minute() - ($scope.calendarConfig.startingHour * 60) + paddingTop);
		}
		
		function getDateByYPosition(yPosition) {
			var minuteCount = yPosition;
			
			var hour = minuteCount / 60;
			var minute = minuteCount % 60;
			
			var targetDate = moment($scope.calendarDate);
			targetDate.set({'hour': hour + $scope.calendarConfig.startingHour, 'minute': minute, 'second': 0});
			
			return targetDate.clone().toDate();
		}
		
		function scrollToTop() {
			var calendarContainer = $('#calendarContainer');
			if (calendarContainer.length > 0) {
				calendarContainer[0].scrollTop = 0;
			}
			else {
				$timeout(scrollToTop);
			}
		}
		
		function scrollToDate(date) {
			var calendarContainer = $('#calendarContainer');
			if (calendarContainer.length > 0) {
				var position = getYPositionByDate(date);
				calendarContainer[0].scrollTop = position + 20; // + margin of tolerance before?
			}
			else {
				$timeout(function () {
					scrollToDate(date)
				});
			}
		}
		
		function createMonthItems(date) {
			var monthItems = [];
			
			var start = moment('01-01 00:00', 'MM-DD HH:mm');
			start.year(moment(date).year());
			monthItems.push(start.clone().toDate());
			
			while (start.month() < 11) {
				start.add(1, 'months');
				monthItems.push(start.clone().toDate());
			}
			
			return monthItems;
		}
		
		function createYearItems() {
			var yearItems = [];
			
			var start = moment('01-01 00:00', 'MM-DD HH:mm');
			start.subtract(3, 'years');
			
			yearItems.push(start.clone().toDate());
			
			for (var i = 0; i < 6; i++) {
				start.add(1, 'year');
				yearItems.push(start.clone().toDate());
			}
			
			return yearItems;
		}
		
		function createCalendarTimeItems() {
			var calendarTimeItems = [];
			
			var calendarDateMoment = moment($scope.calendarDate);
			calendarDateMoment.set({'hour': 0, 'minute': 0, 'second': 0});
			
			var endOfDay = false;
			
			while (!endOfDay) {
				calendarTimeItems.push(objectHelper.o(CalendarTimeItemLocalVO, {
					id: 'calendarTimeItem_' + _.padStart(calendarDateMoment.hour(), 2, '0') + '_' + _.padStart(calendarDateMoment.minute(), 2, '0'),
					timeEventColumnCount: 0,
					timeEvents: [],
					date: calendarDateMoment.clone().toDate(),
					isCalendarLine: (calendarDateMoment.minute() % 10 == 0),
					isFullHour: (calendarDateMoment.minute() == 0),
					visible: (calendarDateMoment.hour() >= $scope.calendarConfig.startingHour)
				}));
				
				calendarDateMoment.add(5, 'minutes');
				
				if ((calendarDateMoment.hour() == 0) && (calendarDateMoment.minute() == 0)) {
					endOfDay = true;
				}
			}
			
			return calendarTimeItems;
		}
		
		function resetCalendarItems(calendarTimeItems) {
			_.each(calendarTimeItems, function (calendarTimeItem) {
				calendarTimeItem.timeEvents = [];
				calendarTimeItem.timeEventColumnCount = 0;
				
				// since this is called whenever the calendar date is changed, we need to update the internal date for each calendarTimeItem
				// it is used further by the layout algorithm and comparison needs exact same dates
				var date = moment(calendarTimeItem.date);
				var calendarDateMoment = moment($scope.calendarDate);
				date.set({
					'year': calendarDateMoment.year(),
					'month': calendarDateMoment.month(),
					'date': calendarDateMoment.date()
				});
				
				calendarTimeItem.date = date.clone().toDate();
			});
		}
		
		function createCalendarTimeEvents(events) {
			var calendarTimeEvents = [];
			_.each(events, function (event, index) {
				
				if (event instanceof TermMeedyVO) {
					var calendarTimeItem = objectHelper.o(CalendarTimeEventLocalVO, {
						id: 'calendarTimeEvent_' + (index + 1),
						startDate: event.begin,
						displayStartDate: event.begin,
						endDate: event.end,
						displayEndDate: event.end,
						duration: moment(event.end).diff(moment(event.begin), 'minutes'),
						displayDuration: moment(event.end).diff(moment(event.begin), 'minutes'),
						columnIndex: NaN,
						columnSpan: 1,
						color: getColorForTerm(event),
						opacity: 1,
						// zIndex: NaN,
						zIndex: 11,
						type: Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.TERM,
						data: event,
						resourceColumnIndex: ($scope.availabilityIndexes[event.resource.id]) ? $scope.availabilityIndexes[event.resource.id].idxOffset : NaN
					});
					
					if ((moment(calendarTimeItem.displayStartDate).hours() < $scope.calendarConfig.startingHour) && (moment(calendarTimeItem.endDate).hours() > $scope.calendarConfig.startingHour)) {
						calendarTimeItem.displayStartDate = moment(calendarTimeItem.displayStartDate).set({
							'hour': $scope.calendarConfig.startingHour,
							'minute': 0,
							'second': 0
						}).clone().toDate();
					}
					
					if (moment(calendarTimeItem.displayEndDate).diff(moment(calendarTimeItem.displayStartDate), 'minutes') < 15) {
						calendarTimeItem.displayEndDate = moment(calendarTimeItem.displayStartDate).clone().add(15, 'minute').clone().toDate();
					}
					
					calendarTimeItem.displayDuration = moment(calendarTimeItem.displayEndDate).diff(moment(calendarTimeItem.displayStartDate), 'minutes');
					
					calendarTimeEvents.push(calendarTimeItem);
				}
				else if (event instanceof AvailabilityRuleOccurrenceMeedyVO) {
					// availability rule doesn't have the proper date, just the hour. We need to take the rest of the date from current calendar date and apply
					var calendarDateMoment = moment($scope.calendarDate);
					var availabilityRuleOccurrenceStartDateMoment = moment(event.startTime);
					var availabilityRuleOccurrenceEndDateMoment = moment(event.endTime);
					
					availabilityRuleOccurrenceStartDateMoment.set({
						'year': calendarDateMoment.year(),
						'month': calendarDateMoment.month(),
						'date': calendarDateMoment.date()
					});
					availabilityRuleOccurrenceEndDateMoment.set({
						'year': calendarDateMoment.year(),
						'month': calendarDateMoment.month(),
						'date': calendarDateMoment.date()
					});
					var calendarTimeItem = objectHelper.o(CalendarTimeEventLocalVO, {
						id: 'calendarTimeEvent_' + (index + 1),
						startDate: availabilityRuleOccurrenceStartDateMoment.clone().toDate(),
						displayStartDate: availabilityRuleOccurrenceStartDateMoment.clone().toDate(),
						endDate: availabilityRuleOccurrenceEndDateMoment.clone().toDate(),
						displayEndDate: availabilityRuleOccurrenceEndDateMoment.clone().toDate(),
						duration: availabilityRuleOccurrenceEndDateMoment.diff(availabilityRuleOccurrenceStartDateMoment, 'minutes'),
						displayDuration: availabilityRuleOccurrenceEndDateMoment.diff(availabilityRuleOccurrenceStartDateMoment, 'minutes'),
						columnIndex: 1,
						columnSpan: 1,
						color: event.resource.color,
						opacity: 0.12,
						zIndex: 10,
						type: Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.AVAILABILITY,
						data: event,
						resourceColumnIndex: ($scope.availabilityIndexes[event.resource.id]) ? $scope.availabilityIndexes[event.resource.id].idxOffset : NaN
					});
					
					if ((moment(calendarTimeItem.displayStartDate).hours() < $scope.calendarConfig.startingHour) && (moment(calendarTimeItem.endDate).hours() > $scope.calendarConfig.startingHour)) {
						calendarTimeItem.displayStartDate = moment(calendarTimeItem.displayStartDate).set({
							'hour': $scope.calendarConfig.startingHour,
							'minute': 0,
							'second': 0
						}).clone().toDate();
					}
					
					if (moment(calendarTimeItem.displayEndDate).diff(moment(calendarTimeItem.displayStartDate), 'minutes') < 15) {
						calendarTimeItem.displayEndDate = moment(calendarTimeItem.displayStartDate).clone().add(15, 'minute').clone().toDate();
					}
					
					calendarTimeItem.displayDuration = moment(calendarTimeItem.displayEndDate).diff(moment(calendarTimeItem.displayStartDate), 'minutes');
					
					calendarTimeEvents.push(calendarTimeItem);
				}
			});
			
			calendarTimeEvents = _.sortBy(calendarTimeEvents, ['startDate', 'endDate']);
			
			return calendarTimeEvents;
		}
		
		/**
		 * layoutCalendarTimeEvents
		 *
		 * @param calendarTimeItems - all rows in calendar
		 * @param calendarTimeEvents - events to match to calendarTimeItems
		 */
		function layoutCalendarTimeEvents(calendarTimeItems, calendarTimeEvents) {
			
			var calendarColumnsWithSubcolumns = newEmptyCalendarColumnsWithSubcolumns();
			
			_.each(calendarTimeEvents, function (calendarTimeEvent) {
				var resourceColumn = calendarColumnsWithSubcolumns[calendarTimeEvent.data.resource.id];
				if (resourceColumn) {
					insertEventToCorrectResourceSubColumn(resourceColumn, calendarTimeEvent);
				}
			});
			
			_.each(calendarColumnsWithSubcolumns, function (resourceColumn) {
				addTimeEventsToTimeItemsAndSetColumnSpan(resourceColumn.subColumns, calendarTimeItems);
			});
			
		}
		
		function newEmptyCalendarColumnsWithSubcolumns() {
			var subColumnsIndex = 0;
			return _.reduce($scope.availabilityIndexes, function (acc, val, idx) {
				acc[idx] = {
					index: subColumnsIndex++,
					subColumns: []
				};
				return acc;
			}, {});
		}
		
		function insertEventToCorrectResourceSubColumn(resourceColumn, calendarTimeEvent) {
			var assigned = false;
			
			var calendarTimeEventMomentRange = moment.range(calendarTimeEvent.startDate, calendarTimeEvent.displayEndDate);
			
			// Arrange events in columns. Find out if event overlaps with anything in current column (that is term),
			// if not, insert, otherwise move to the next column, finally insert into newly created column
			for (var columnIndex = 0; columnIndex < (resourceColumn.subColumns.length) && (!assigned); columnIndex++) {
				var currentColumn = resourceColumn.subColumns[columnIndex];
				
				// availability should always lands in the first column anyway, as it stretches max width and "below" events
				if (calendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.AVAILABILITY) {
					pushTimeEventIntoColumnAndAdjustData(currentColumn, calendarTimeEvent, resourceColumn.index, columnIndex);
					assigned = true;
				} else {
					var lastCalendarTimeEventInCurrentColumn = null;
					
					// search for previous event in column, but watch out for availabilities - we ignore them for "overlapping" purposes, so look only for term
					for (var j = currentColumn.length - 1; j >= 0; j--) {
						var previousCalendarTimeEventInColumn = currentColumn[j];
						
						if (previousCalendarTimeEventInColumn.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.TERM) {
							lastCalendarTimeEventInCurrentColumn = previousCalendarTimeEventInColumn;
							break;
						}
					}
					
					// if term found, calculate the overlap, if does not overlap, push into the same column (below)
					if (lastCalendarTimeEventInCurrentColumn) {
						var lastCalendarTimeEventInCurrentColumnMomentRange = moment.range(lastCalendarTimeEventInCurrentColumn.startDate, lastCalendarTimeEventInCurrentColumn.displayEndDate);
						
						if (!calendarTimeEventMomentRange.overlaps(lastCalendarTimeEventInCurrentColumnMomentRange)) {
							pushTimeEventIntoColumnAndAdjustData(currentColumn, calendarTimeEvent, resourceColumn.index, columnIndex);
							assigned = true;
						}
						
					} else { // if term not found, it means that this column had only availabilities so far, so we can safely push into the same column (below), as we don't care about overlap with availabilities
						pushTimeEventIntoColumnAndAdjustData(currentColumn, calendarTimeEvent, resourceColumn.index, columnIndex);
						assigned = true;
					}
				}
			}
			
			// if nothing really fits, just create new column and add it there
			if (!assigned) {
				resourceColumn.subColumns.push([]);
				var columnIndex = resourceColumn.subColumns.length - 1;
				pushTimeEventIntoColumnAndAdjustData(resourceColumn.subColumns[columnIndex], calendarTimeEvent, resourceColumn.index, columnIndex)
			}
		}
		
		function pushTimeEventIntoColumnAndAdjustData(column, calendarTimeEvent, resourceColumnIndex, columnIndex) {
			column.push(calendarTimeEvent);
			calendarTimeEvent.resourceColumnIndex = resourceColumnIndex;
			calendarTimeEvent.columnIndex = columnIndex;
			// TERM always on top of AVAILABILITY and higher than last TERM
			calendarTimeEvent.zIndex = (calendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.TERM) ? 10 + column.length : 10;
		}
		
		function addTimeEventsToTimeItemsAndSetColumnSpan(subColumns, calendarTimeItems) {
			_.each(subColumns, function (subColumn, subColumnIndex) {
				_.each(subColumn, function (calendarTimeEvent) {
					calendarTimeEvent.timeEventColumnCount = subColumns.length;
					
					var calendarTimeItem = getTimeItemForTimeEvent(calendarTimeEvent, calendarTimeItems);
					if (calendarTimeItem) {
						
						
						// if it's availability, span through all columns
						if (calendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.AVAILABILITY) {
							calendarTimeEvent.columnSpan = subColumns.length;
						} else {
							
							var calendarTimeEventMomentRange = moment.range(calendarTimeEvent.startDate, calendarTimeEvent.displayEndDate);
							for (var j = subColumnIndex + 1; j < subColumns.length; j++) {
								var isOverlapping = false;
								
								var nextCalendarTimeEventColumn = subColumns[j];
								
								_.each(nextCalendarTimeEventColumn, function (nextCalendarTimeEvent) {
									// consider only terms, when calculating overlaps
									if (nextCalendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.TERM) {
										var nextCalendarTimeEventMomentRange = moment.range(nextCalendarTimeEvent.startDate, nextCalendarTimeEvent.displayEndDate);
										if (calendarTimeEventMomentRange.overlaps(nextCalendarTimeEventMomentRange)) {
											isOverlapping = true;
										}
									}
								});
								
								if (!isOverlapping) {
									calendarTimeEvent.columnSpan++;
								}
								else {
									break;
								}
							}
							
						}
						
						calendarTimeItem.timeEvents.push(calendarTimeEvent);
					}
					
				});
			});
		}
		
		function getTimeItemForTimeEvent(calendarTimeEvent, calendarTimeItems) {
			
			var calendarTimeEventStartDateMoment = moment(calendarTimeEvent.displayStartDate);
			return _.find(calendarTimeItems, function (calendarTimeItem) {
				var calendarTimeItemMoment = moment(calendarTimeItem.date);
				return (calendarTimeItemMoment.isSame(calendarTimeEventStartDateMoment, 'hour') && calendarTimeItemMoment.isSame(calendarTimeEventStartDateMoment, 'minute'));
			});
		}
		
		function configureCalendarButtons() {
			$scope.calendarButtonsReady = false;
			var calendarContainer = $('#calendarContainer');
			if (calendarContainer.length > 0) {
				$timeout(positionCalendarButtons, 500);
				calendarContainer.off('scroll');
				calendarContainer.on('scroll', function ($event) {
					positionCalendarButtons();
				});
			}
			else {
				$timeout(configureCalendarButtons);
			}
		}
		
		function positionCalendarButtons() {
			var calendarPreviousButton = $('.calendarPreviousButton');
			var calendarNextButton = $('.calendarNextButton');
			var calendarContainer = $('#calendarContainer');
			var calendar = $('#calendar');
			
			if ((calendarPreviousButton.length > 0) && (calendarNextButton.length > 0) && (calendarContainer.length > 0) && (calendar.length > 0)) {
				calendarPreviousButton.css({'top': (calendarContainer.height() / 2) - (calendarPreviousButton.height() / 2) - (calendar.offset().top - calendarContainer.offset().top)});
				calendarNextButton.css({'top': (calendarContainer.height() / 2) - (calendarNextButton.height() / 2) - (calendar.offset().top - calendarContainer.offset().top)});
				
				$scope.calendarButtonsReady = true;
			}
			else {
				$timeout(positionCalendarButtons);
			}
		}
		
		function determineCurrentDatePointerVisibility() {
			// don't show it near the full hours, it overlaps and looks ugly
			
			var currentMoment = moment($scope.currentDate);
			var currentMinutes = currentMoment.minute();
			if ((currentMinutes < 10) || (currentMinutes > 50)) {
				$scope.currentDatePointerShowFull = false;
			}
			else {
				$scope.currentDatePointerShowFull = true;
			}
		}
		
		function initializeTimePolling() {
			var now = moment();
			var currentSeconds = now.seconds();
			
			// calculate the exact starting point for the next minute, let's be exact with system time
			var remainingSecondsToStartPolling = 60 - currentSeconds;
			
			$timeout(function () {
				timePollingPromise = $interval(timePollingAction, (60 * 1000));
				timePollingAction();
			}, (remainingSecondsToStartPolling * 1000));
		}
		
		function timePollingAction() {
			var nextMoment = moment($scope.currentDate).clone();
			nextMoment.add(1, 'minute');
			var nextDate = nextMoment.clone().toDate();
			$scope.currentDatePointerYPosition = getYPositionByDate(nextDate);
			$scope.currentDate = nextDate;
			determineCurrentDatePointerVisibility();
		}
		
		function markResourceTab(resource) {
			// brute-force tab underline coloring, needs special trick to be able to apply !important
			var mdInkBar = $('md-ink-bar');
			if (resource && resource.id > 0) {
				mdInkBar[0].style.setProperty('background-color', resource.color, 'important');
			}
			else {
				mdInkBar[0].style.setProperty('background-color', '', 'important');
			}
		}
		
		function updateStateParameters() {
			// apparently state params updated with notify/reload false aren't preserved in $stateParams or $state.$current
			// (which kinda makes sense, if notify: false, but we want to prevent view reloading, too)
			// we still need these parameters to land in url (so that user can refresh or copy/paste), but we have to also store them internally
			// for daily view / plan view
			$scope.stateParameters = {
				dateSlug: 'date',
				date: $scope.calendarDate.getTime(),
				resourceSlug: 'resource',
				resourceId: $scope.currentResource.id
			};
			$state.transitionTo($state.current, $scope.stateParameters, {notify: false, reload: false});
		}
		
		function recalculateCalendarLayoutInnerWidth(events) {
			if (!$scope.displayAllResources) {
				return;
			}
			var availabilitiesCount = Object.keys($scope.availabilityIndexes).length;
			var columnsCountDiff = availabilitiesCount - $scope.calendarConfig.readableColumnCount;
			
			if (columnsCountDiff > 0) {
				//recalculating resource width just to inform user there are next/hidden resources to the right
				$scope.calendarConfig.allResourcesColumnWidth = Math.floor(($scope.calendarConfig.width - $scope.calendarConfig.labelColumnWidth + $scope.calendarConfig.rightGapWidth - 50) / $scope.calendarConfig.readableColumnCount);
				
				$scope.calendarConfig.innerWidth = (availabilitiesCount * $scope.calendarConfig.allResourcesColumnWidth) + $scope.calendarConfig.labelColumnWidth + $scope.calendarConfig.rightGapWidth;
			}
			if (columnsCountDiff < 0) {
				$scope.calendarConfig.readableColumnCount = availabilitiesCount;
				$scope.calendarConfig.allResourcesColumnWidth = Math.floor(($scope.calendarConfig.width - $scope.calendarConfig.labelColumnWidth + $scope.calendarConfig.rightGapWidth) / $scope.calendarConfig.readableColumnCount);
			}
			
			$scope.maxScrollValue = (Object.keys($scope.availabilityIndexes).length - $scope.calendarConfig.readableColumnCount) * $scope.calendarConfig.allResourcesColumnWidth;
		}
		
		// --- //
		
		function setCalendarConfig() {
			
			var readableColumnCount;
			var mdCardWidth = $('md-card').width();
			var columnsCount = Object.keys($scope.availabilityIndexes).length;
			var calculatedReadableColumnsCount = Math.floor(mdCardWidth / 250) + 1;
			
			if (columnsCount == 0) {
				readableColumnCount = 1;
			} else if (mdCardWidth > 600) {
				readableColumnCount = Math.min(columnsCount, calculatedReadableColumnsCount);
			} else {
				readableColumnCount = 3;
			}
			
			$scope.calendarConfig = objectHelper.o(CalendarConfigLocalVO, {
				startingHour: 6,
				width: mdCardWidth - 300,
				innerWidth: mdCardWidth - 300,
				labelColumnWidth: 60,
				rightGapWidth: 0,
				readableColumnCount: readableColumnCount
			});
			$scope.calendarConfig.allResourcesColumnWidth = Math.floor(($scope.calendarConfig.width - $scope.calendarConfig.labelColumnWidth + $scope.calendarConfig.rightGapWidth) / $scope.calendarConfig.readableColumnCount);
			
			recalculateCalendarLayoutInnerWidth();
		}
		
		function setData() {
			$scope.stateParameters = $stateParams;
			$scope.availabilityIndexes = {};
			
			setCalendarConfig();
			
			$scope.calendarScrollValue = 0;
			$scope.maxScrollValue = 0;
			
			$scope.viewModes = [
				Enum.MEEDY.CALENDAR_VIEW_MODE.DAY,
				Enum.MEEDY.CALENDAR_VIEW_MODE.PLAN
			];
			$scope.currentViewMode = $scope.viewModes[0];
			$scope.termPopupOpened = false;
			
			$scope.calendarReady = false;
			$scope.calendarButtonsReady = false;
			
			$scope.currentDate = new Date();
			$scope.calendarDate = $stateParams.date ? new Date($stateParams.date) : moment('06:00', 'HH:mm').clone().toDate();
			
			$scope.currentDatePointerYPosition = getYPositionByDate($scope.currentDate);
			$scope.currentDatePointerShowFull = false;
			
			$scope.resources = [
				objectHelper.o(ResourceMeedyVO, {
					id: 0,
					name: $scope.T('T.MEEDY.MODULE.CALENDAR.ALL_RESOURCES'),
					color: '#5959ca'
				})
			];
			$scope.currentResource = null;
			
			$scope.moonPhase = null;
			$scope.moonPhaseIconClassName = null;
			$scope.namedays = null;
			
			$scope.monthItems = createMonthItems($scope.calendarDate);
			$scope.yearItems = createYearItems();
			
			$scope.calendarTimeItems = createCalendarTimeItems();
			$scope.events = [];
			
			$scope.availabilityRuleRange = {
				startDate: moment('00:00', 'HH:mm').add(1, 'days').clone().toDate(),
				days: 4
			};
			
			$scope.lastCalendarDataCall = {
				resourceId: undefined,
				startDate: undefined,
				calendarType: undefined
			};
			
			$scope.upcomingTerms = [];
			$scope.searchText = null;
			$scope.searchSelectedItem = null;
		}
		
		function setPermissions() {
			$scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
			$scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
				|| userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
		}
		
		function setListeners() {
			
			$scope.$on('$destroy', function (event) {
				applicationModel.viewReady = false;
				$('#calendarContainer').off('scroll');
				$($window).off('resize', positionCalendarButtons);
				$interval.cancel(timePollingPromise);
			});
			
			// since calendar has ng-if, these will be detached from DOM, we have to reattach whenever they appear (after calendarReady = true)
			$scope.$watch('calendarReady', function (newVal, oldVal) {
				if (newVal) {
					configureCalendarButtons();
				}
			}, false);
			
			
			$(window).resize(function () {
				setCalendarConfig();
				$scope.$apply();
			});
			
			$scope.$on(Event.MEEDY.RESOURCE.GET_RESOURCES_AVAILABLE_FOR_LOGGED_USER.SUCCESS, function (event, resources) {
				if (!$scope.termPopupOpened) {
					$scope.resources = [
						objectHelper.o(ResourceMeedyVO, {
							id: 0,
							name: $scope.T('T.MEEDY.MODULE.CALENDAR.ALL_RESOURCES'),
							color: '#5959ca'
						})
					];
					$scope.resources = $scope.resources.concat(resources);
					
					$scope.selectedResource = $scope.resources[0];
					
					var resource = $scope.resources[0];
					
					if ($stateParams.resourceId) {
						var foundResource = _.find($scope.resources, function (resource) {
							return (resource.id == $stateParams.resourceId);
						});
						
						if (foundResource) {
							resource = foundResource;
						}
					}
					
					$scope.currentResource = resource;
					
					//markResourceTab(resource);
					calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
					
					updateStateParameters();
				}
			});
			
			$scope.$on(Event.MEEDY.CALENDAR.GET_MOON_PHASE.SUCCESS, function (event, moonPhase) {
				$scope.moonPhase = moonPhase;
				
				// because why having sane class names for icons, right? right?
				var className = '';
				switch (moonPhase) {
					case Enum.MEEDY.MOON_PHASE.NEW:
						className = 'flaticon-new42';
						break;
					case Enum.MEEDY.MOON_PHASE.WAXING_CRESCENT:
						className = 'flaticon-moon113';
						break;
					case Enum.MEEDY.MOON_PHASE.FIRST_QUARTER:
						className = 'flaticon-half21';
						break;
					case Enum.MEEDY.MOON_PHASE.WAXING_GIBBOUS:
						className = 'flaticon-moon103';
						break;
					case Enum.MEEDY.MOON_PHASE.FULL:
						className = 'flaticon-moon99';
						break;
					case Enum.MEEDY.MOON_PHASE.WANING_GIBBOUS:
						className = 'flaticon-moon110';
						break;
					case Enum.MEEDY.MOON_PHASE.THIRD_QUARTER:
						className = 'flaticon-moon94';
						break;
					case Enum.MEEDY.MOON_PHASE.WANING_CRESCENT:
						className = 'flaticon-moon108';
						break;
				}
				$scope.moonPhaseIconClassName = className;
			});
			
			$scope.$on(Event.MEEDY.CALENDAR.GET_NAMEDAYS.SUCCESS, function (event, namedays) {
				$scope.namedays = namedays;
			});
			
			$scope.$on(Event.MEEDY.CALENDAR.GET_CALENDAR_DATA_FOR_RESOURCE.SUCCESS, function (event, calendarData) {
				$scope.events = [];
				$scope.availabilityIndexes = {};
				
				// pluck the events from within the map structure, reattach resources (that were stripped, but their ids are passed as map keys)
				_.forOwn(calendarData, function (calendarDataItem, key) {
					processCalendarDataItem(calendarDataItem);
				});
				
				var calendarDateMoment = moment($scope.calendarDate);
				var lastCalendarDateCallMoment = moment($scope.lastCalendarDataCall.startDate);
				var isSameResource = ($scope.currentResource.id == $scope.lastCalendarDataCall.resourceId);
				$scope.displayAllResources = ($scope.currentResource.id === 0);
				
				if ((!isSameDate(lastCalendarDateCallMoment, calendarDateMoment) || !isSameResource) && !_.isUndefined($scope.lastCalendarDataCall.calendarType)) {
					// set calendar starting hour
					$scope.setCalendarStartingHour(6, false);
				}
				
				var calendarTimeEvents = createCalendarTimeEvents($scope.events);
				
				setCalendarConfig();
				
				resetCalendarItems($scope.calendarTimeItems);
				layoutCalendarTimeEvents($scope.calendarTimeItems, calendarTimeEvents);
				
				$timeout(function () {
					$scope.currentDatePointerYPosition = getYPositionByDate($scope.currentDate);
				});
				
				
				$scope.calendarReady = true;
				
				$scope.lastCalendarDataCall.resourceId = $scope.currentResource.id;
				$scope.lastCalendarDataCall.startDate = $scope.calendarDate;
				$scope.lastCalendarDataCall.calendarType = Enum.MEEDY.CALENDAR_TYPE.DAILY;
				
				
			});
			
			function processCalendarDataItem(calendarDataItem) {
				var presentResources = {};
				
				_.forOwn(calendarDataItem.availabilities, function (resourceAvailabilities, resourceId) {
					updatePresentResources(presentResources, resourceId);
					
					_.each(resourceAvailabilities, function (availability) {
						availability.resource = presentResources[resourceId];
						$scope.events.push(availability);
					});
				});
				
				_.forOwn(calendarDataItem.terms, function (resourceTerms, resourceId) {
					updatePresentResources(presentResources, resourceId);
					
					_.each(resourceTerms, function (term) {
						term.resource = presentResources[resourceId];
						
						if (term.allDay) {
							term.end = new Date(term.begin).setHours(23, 55, 0, 0);
						}
						$scope.events.push(term);
					});
				});
				
				var idxOffset = 0;
				_.forEach($scope.resources, function (resource) {
					if(presentResources[resource.id]){
						$scope.availabilityIndexes[resource.id] = {
							idxOffset: idxOffset,
							name: resource.name,
							color: resource.color
						};
						idxOffset++;
					}
				});
				
				
			}
			
			function updatePresentResources(presentResources, resourceId) {
				if(!presentResources[resourceId]) {
					presentResources[resourceId] = _.find($scope.resources, function (resource) {
						return (resource.id == parseInt(resourceId));
					});
				}
			}
			
			$scope.$on(Event.MEEDY.AVAILABILITY_RULE.GET_NEAREST_AVAILABILITY_RULE_OCCURENCE.SUCCESS, function (event, data) {
				if (!$scope.termPopupOpened) {
					var upcomingTerms = _.sortBy(data, ['startDate']);
					var upcomingTermsByDay = _.groupBy(upcomingTerms, function (availabilityRuleOccurrence) {
						return moment(availabilityRuleOccurrence.startDate).dayOfYear();
					});
					
					$scope.upcomingTerms = upcomingTermsByDay;
				}
			});

			$scope.querySearch = function(query) {
				return new Promise(function(resolve, reject) {
					var allVisits = [];
					calendarModel.searchMeedyPatients({searchPhrase: query})
						.then(function (patients) {
							patients.forEach(function (patient) {
								termModel.getTerms({
									idPatient: patient.id,
									types: [Enum.MEEDY.TERM_TYPE.EXTERNAL, Enum.MEEDY.TERM_TYPE.INTERNAL, Enum.MEEDY.TERM_TYPE.PRESCRIPTION],
									appointmentStatuses: ['PRERESERVATION', 'IN_PROGRESS', 'RESERVATION', 'PRERESERVATION_FINISHED', 'DONE'],
									startDate: new Date(),
									sortColumns: [{
										columnName: 'begin',
										descending: true
									}]
								}).then(function (visits) {
										visits.data.forEach(function (visit) {
											var el = {
												value: visit,
												display: `${visit.patientFirstName} ${visit.patientLastName} | ${visit.patientIdentifier} | ${new Date(visit.begin).toLocaleDateString()} ${new Date(visit.begin).getHours().toString().padStart(2, '0')}:${new Date(visit.begin).getMinutes().toString().padStart(2, '0')}`
											};
											allVisits.push(el);
										});
									});
							});
							$timeout(function () { resolve(allVisits) }, 900, false);
						});
				});
			}

			$scope.onCalendarClick = function ($event, resource) {
				// determine offset (various click targets possible + offset reported by browser are sometimes wonky
				var offset = null;
				
				var calendarEventColumn = $('#calendarEventColumn');
				if ($event.target.id != calendarEventColumn.id) {
					offset = $event.offsetY + ($($event.target).offset().top - calendarEventColumn.offset().top);
				}
				else {
					offset = $event.offsetY;
				}
				
				// round to nearest 5 (down or up)
				var clickedDate = getDateByYPosition(offset);
				var targetDateMoment = moment(clickedDate);
				var minutesInTen = targetDateMoment.minute() % 10;
				
				if (minutesInTen > 5) {
					targetDateMoment.minute(targetDateMoment.minute() - (minutesInTen - 5));
				}
				else {
					targetDateMoment.minute(targetDateMoment.minute() - minutesInTen);
				}
				
				var targetDate = targetDateMoment.clone().toDate();
				
				$scope.createTerm(targetDate, resource);
			};
			
			$scope.onCalendarButtonDateChanged = function (date) {
				$scope.goToDate(date);
			};
			
			$scope.onCurrentViewModeChange = function () {
				if ($scope.currentViewMode == Enum.MEEDY.CALENDAR_VIEW_MODE.PLAN) {
					$state.go(Constant.STATE.APP.MEEDY.CALENDAR.DAILY_PLAN, $scope.stateParameters);
				}
			};
			
			$scope.onCalendarTimeEventClick = function ($event, calendarTimeEvent) {
				if (calendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.TERM) {
					$event.stopImmediatePropagation();
					$scope.showTerm(calendarTimeEvent.data);
				} else if (calendarTimeEvent.type == Enum.MEEDY.CALENDAR_TIME_EVENT_TYPE.AVAILABILITY) {
					$event.stopImmediatePropagation();
					$scope.onCalendarClick($event, calendarTimeEvent.data.resource);
				}
			};
		}
		
		function setActions() {
			$scope.setCalendarStartingHour = function (startingHour, forceLayout) {
				$scope.calendarReady = false;
				
				$scope.calendarConfig.startingHour = startingHour;
				
				if (forceLayout) {
					var calendarTimeEvents = createCalendarTimeEvents($scope.events);
					resetCalendarItems($scope.calendarTimeItems);
					layoutCalendarTimeEvents($scope.calendarTimeItems, calendarTimeEvents);
				}
				
				_.each($scope.calendarTimeItems, function (calendarTimeItem) {
					calendarTimeItem.visible = (moment(calendarTimeItem.date).hour() >= $scope.calendarConfig.startingHour);
				});
				
				$scope.currentDatePointerYPosition = getYPositionByDate($scope.currentDate);
				
				$scope.calendarReady = true;
				
				/*
				 $timeout(function() {
				 scrollToTop();
				 });
				 */
			};
			
			$scope.showFullCalendar = function () {
				$scope.setCalendarStartingHour(0, true);
			};
			
			$scope.showShortenedCalendarButton = function () {
				$scope.setCalendarStartingHour(6, true);
			};
			
			$scope.showMoreUpcomingTerms = function () {
				$scope.availabilityRuleRange.days = $scope.availabilityRuleRange.days + 4;
				availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
					startDate: $scope.availabilityRuleRange.startDate,
					days: $scope.availabilityRuleRange.days
				}));
			};
			
			$scope.showEventsForResource = function (resource) {
				if (!resource) {
					return;
				}
				
				// don't enter on initial buggy md-on-select trigger on tabs, calendarReady is never true yet at this point, so we can use it
				if ($scope.calendarReady) {
					$scope.currentResource = resource;
					
					//markResourceTab(resource);
					
					$scope.calendarReady = false;
					updateStateParameters();
					calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
				}
			};
			
			$scope.showTerm = function (term) {
				if (!($scope.isReceptionist && term.type === Enum.MEEDY.TERM_TYPE.PRIVATE_TERM)) {
					var termId = term.id;
					$scope.termPopupOpened = true;
					
					$mdDialog.show({
						templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-view-popup.html',
						controller: 'meedy.popupCalendarTermViewController',
						resolve: {
							termId: function () {
								return termId;
							}
						}
					}).then(function (dialogResult) {
						$scope.termPopupOpened = false;
						
						if (dialogResult) {
							var term = dialogResult.data;
							var eventName = dialogResult.eventName;
							
							if ((eventName == Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_DELETE) || (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.AFTER_CYCLIC_DELETE)) {
								var toast = $mdToast.simple()
									.textContent($scope.T('T.MEEDY.MODULE.CALENDAR.TERM.TERM_DELETED'))
									//.action($scope.T('T.MEEDY.MODULE.CALENDAR.TERM.RESTORE_TERM'))
									.position('top right');
								
								$mdToast.show(toast).then(function (response) {
									// toast has only one action, and that action has 'ok' response, otherwise the resolve action is true
									if (response == 'ok') {
										//console.log('przywroc termin');
										//console.log(term);
									}
								});
								
								if (term) {
									var termBeginMoment = moment(term.begin);
									var calendarDateMoment = moment($scope.calendarDate);
									
									if (isSameDate(termBeginMoment, calendarDateMoment)) {
										calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
									}
								}
							}
							else if (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.EDIT) {
								$scope.editTerm(term, true);
							}
							else if (eventName == Constant.MEEDY.DIALOG_EVENT.TERM.CANCEL) {
								$scope.cancelTerm(term, true);
							}
						}
						
					}, function (error) {
						$scope.termPopupOpened = false;
						calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
					})
				}
			};
			
			$scope.createTerm = function (date, resource) {
				$scope.termPopupOpened = true;
				
				$mdDialog.show({
					templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-create-popup.html',
					controller: 'meedy.popupCalendarTermCreateController',
					resolve: {
						date: function () {
							return date;
						},
						resource: function () {
							return resource;
						},
						termWrapper: function () {
							return {};
						}
					}
				}).then(function (newTerm) {
					$scope.termPopupOpened = false;
					
					if (newTerm) {
						
						var newTermBeginMoment = moment(newTerm.begin);
						var calendarDateMoment = moment($scope.calendarDate);
						
						if (isSameDate(newTermBeginMoment, calendarDateMoment)) {
							calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
						}
					}
				}, function (error) {
					$scope.termPopupOpened = false;
				})
			};
			
			$scope.editTerm = function (term, goBack) {
				$scope.termPopupOpened = true;
				
				$mdDialog.show({
					templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-edit-popup.html',
					controller: 'meedy.popupCalendarTermEditController',
					resolve: {
						term: function () {
							return term;
						},
						termWrapper: function () {
							return {};
						}
					}
				}).then(function (editedTerm) {
					$scope.termPopupOpened = false;
					
					if (editedTerm) {
						var previousTermBeginMoment = moment(term.begin);
						var termBeginMoment = moment(editedTerm.begin);
						var calendarDateMoment = moment($scope.calendarDate);
						
						if (isSameDate(termBeginMoment, calendarDateMoment) || isSameDate(previousTermBeginMoment, calendarDateMoment)) {
							calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
						}
						
						if (goBack) {
							$scope.showTerm(editedTerm);
						}
					}
					
				}, function () {
					$scope.termPopupOpened = false;
					if (goBack) {
						$scope.showTerm(term);
					}
				});
			};
			
			$scope.cancelTerm = function (term, goBack) {
				$scope.termPopupOpened = true;
				
				$mdDialog.show({
					templateUrl: 'meedy/application/view/app/calendar/popup/calendar-term-cancel-popup.html',
					controller: 'meedy.popupCalendarTermCancelController',
					resolve: {
						term: function () {
							return term;
						}
					}
				}).then(function () {
					$scope.termPopupOpened = false;
					if (goBack) {
						$scope.showTerm(term);
					}
				}, function () {
					$scope.termPopupOpened = false;
					if (goBack) {
						$scope.showTerm(term);
					}
				})
			};
			
			$scope.goToDateAndResource = function (upcomingTerm, respectTime) {
				if (!($scope.currentResource.id == 0 || $scope.currentResource.id == upcomingTerm.resource.id)) {
					$scope.currentResource = upcomingTerm.resource;
					
					markResourceTab(upcomingTerm.resource);
				}
				$scope.goToDate(upcomingTerm.startDate, respectTime);
				
			};
			
			$scope.goToDate = function (date, respectTime) {
				var targetDate = moment(date);
				if (!respectTime) {
					targetDate.set({'hour': 0, 'minute': 0, 'second': 0});
				}
				
				$scope.calendarDate = targetDate.clone().toDate();
				
				calendarModel.getMoonPhase($scope.calendarDate);
				calendarModel.getNameDays($scope.calendarDate);
				
				$scope.calendarReady = false;
				updateStateParameters();
				calendarModel.getCalendarDataForResource($scope.currentResource.id, $scope.calendarDate, Enum.MEEDY.CALENDAR_TYPE.DAILY);
				
				$scope.monthItems = createMonthItems(targetDate);
			};
			
			$scope.goToPreviousDay = function () {
				$scope.goToDate(moment($scope.calendarDate).subtract(1, 'days').toDate());
			};
			
			$scope.goToNextDay = function () {
				$scope.goToDate(moment($scope.calendarDate).add(1, 'days').toDate());
			};
			
			$scope.goToSameMonthDate = function (date) {
				var calendarDate = moment($scope.calendarDate);
				var targetMonth = moment(date);
				
				var targetDate = calendarDate.clone().month(targetMonth.month()).toDate();
				$scope.goToDate(targetDate);
			};
			
			$scope.goToSameYearDate = function (date) {
				var calendarDate = moment($scope.calendarDate);
				var targetYear = moment(date);
				
				var targetDate = calendarDate.clone().year(targetYear.year()).toDate();
				$scope.goToDate(targetDate);
			};
			
			$scope.goToToday = function () {
				$scope.goToDate(new Date());
			};
			
			$scope.goToTomorrow = function () {
				$scope.goToDate(moment().add(1, 'days').toDate());
			};
			
			$scope.isMonthPressed = function (calendarDate, targetDate) {
				var calendarDateMoment = moment(calendarDate);
				var targetDateMoment = moment(targetDate);
				return (calendarDateMoment.isSame(targetDateMoment, 'month'));
			};
			
			$scope.isYearPressed = function (calendarDate, targetDate) {
				var calendarDateMoment = moment(calendarDate);
				var targetDateMoment = moment(targetDate);
				return (calendarDateMoment.isSame(targetDateMoment, 'year'));
			};
			
			$scope.isTodayPressed = function (calendarDate) {
				var calendarDateMoment = moment(calendarDate);
				var today = moment();
				return isSameDate(today, calendarDateMoment);
			};
			
			$scope.isTomorrowPressed = function (calendarDate) {
				var calendarDateMoment = moment(calendarDate);
				var tomorrow = moment().add(1, 'days');
				return isSameDate(tomorrow, calendarDateMoment);
			};
			
			$scope.calculateLeftPad = function (calendarTimeEventIndex) {
				return calendarTimeEventIndex * 200;
			};
			
			$scope.scrollCalendar = function (toRight) {
				if (toRight) {
					$scope.calendarScrollValue += $scope.calendarConfig.allResourcesColumnWidth;
				} else {
					$scope.calendarScrollValue -= $scope.calendarConfig.allResourcesColumnWidth;
				}
				if ($scope.calendarScrollValue <= $scope.maxScrollValue) {
					$("#calendarEventColumn").scrollLeft($scope.calendarScrollValue);
				}
			};
		}
		
		function configureInterface() {
			applicationModel.selectSideBarItemWithState(Constant.STATE.APP.MEEDY.CALENDAR.INDEX);
			
			var breadcrumbItems = [];
			applicationModel.setBreadcrumbItems(breadcrumbItems);
			applicationModel.setTitleBar('T.MEEDY.MODULE.CALENDAR.CALENDAR_DAILY');
			
			$($window).resize(positionCalendarButtons);
		}
		
		function initialize() {
			applicationModel.viewReady = true;
			applicationModel.fillViewportMode = true;
			
			determineCurrentDatePointerVisibility();
			initializeTimePolling();
			
			resourceModel.getResourcesAvailableForLoggedUser();
			availabilityRuleModel.getNearestAvailabilityRuleCacheOccurence(objectHelper.o(AvailabilityRuleOccurenceCacheDataGridMeedyCriteria, {
				startDate: $scope.availabilityRuleRange.startDate,
				days: $scope.availabilityRuleRange.days
			}));
			
			calendarModel.getMoonPhase($scope.calendarDate);
			calendarModel.getNameDays($scope.calendarDate);
		}
		
		setData();
		setPermissions();
		setListeners();
		setActions();
		configureInterface();
		initialize();
	}
]);
